import { useState, useMemo, useEffect } from 'react'

export interface Paginated<T> {
  page: number
  setPage: (newPage: number) => void
  maxPage: number
  shown: T[]
}

interface Props<T> {
  data: T[]
  pageSize: number
}

export function usePagination<T>(
  opts: Props<T>,
  deps: unknown[]
): Paginated<T> {
  const { data, pageSize } = opts

  const [page, setPage] = useState(1)
  const maxPage = Math.ceil((data?.length || 0) / pageSize)

  const shown = useMemo(() => {
    if (!data?.length) return []
    const cursor = (page - 1) * pageSize
    return data.slice(cursor, cursor + pageSize)
  }, [data, page])

  useEffect(() => {
    setPage(1)
  }, deps)

  return {
    page,
    setPage,
    maxPage,
    shown,
  }
}
